import React from "react";

const contextFields = [
  ["Owner", "owner"],
  ["Status", "status"],
  ["Revision", "revision"],
  ["Next action", "nextAction"],
  ["Approvals", "approvals"],
];

export function ObjectContext({ object = {} }) {
  return (
    <aside className="lw-object" aria-label="Active object context">
      <div className="lw-object__media" aria-label={object.mediaLabel || "Object preview"}>
        {object.imageUrl ? <img src={object.imageUrl} alt={object.imageAlt || object.name || ""} /> : null}
        {object.renderMedia ? object.renderMedia(object) : null}
        {!object.imageUrl && !object.renderMedia ? (
          <div className="lw-object__media-placeholder">
            <span>No render yet</span>
          </div>
        ) : null}
      </div>
      <div className="lw-object__identity">
        <span>{object.kind || "Active object"}</span>
        <strong>{object.name || "No object selected"}</strong>
      </div>
      <dl className="lw-object__facts">
        {contextFields.map(([label, key]) => (
          <div key={key}>
            <dt>{label}</dt>
            <dd>{object[key] || "—"}</dd>
          </div>
        ))}
      </dl>
    </aside>
  );
}
